import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "./contact.css";
import Seo from "../../components/seo/Seo";
import { siteMeta, spreekuren } from "../../data/siteContent";

export default function Contact() {
    const form = useRef();
    const [status, setStatus] = useState("idle");

    const handleVerzenden = async (event) => {
        event.preventDefault();
        setStatus("sending");

        try {
            await emailjs.sendForm(
                "service_k5uysut",
                "template_n4ijboz",
                form.current,
                "K26pZOU-pqgwRUtgF"
            );
            setStatus("sent");
            form.current.reset();
        } catch (error) {
            setStatus("error");
        }
    };

    return (
        <>
            <Seo
                title="Contact met diëtist Rita Wilschut in Breda"
                description="Neem contact op met Vandaag Begin Ik, diëtistenpraktijk in Breda, voor voedingsadvies, dieetadvies en leefstijlbegeleiding."
                path="/contact"
            />

            <section className="page-intro">
                <p className="section-label">Contact</p>
                <h1>Neem vrijblijvend contact op.</h1>
                <p>
                    Het streven is uw bericht binnen 2 werkdagen te beantwoorden. Mocht u dan niets
                    hebben vernomen, kijk dan in de spam box of bij ongewenste berichten.
                </p>
            </section>

            <section className="contact-layout">
                <div className="contact-panel">
                    <h2>Stuur een bericht</h2>
                    <form ref={form} onSubmit={handleVerzenden} className="contact-form">
                        <div className="contact-form__row">
                            <label>
                                Voornaam *
                                <input type="text" name="voorNaam" required />
                            </label>
                            <label>
                                Achternaam *
                                <input type="text" name="achterNaam" required />
                            </label>
                        </div>

                        <label>
                            Telefoonnummer *
                            <input type="text" name="telefoonnummer" required />
                        </label>

                        <label>
                            E-mail
                            <input type="email" name="email" />
                        </label>

                        <label>
                            Bericht *
                            <textarea name="bericht" rows="7" required />
                        </label>

                        <button type="submit" className="button-primary" disabled={status === "sending"}>
                            {status === "sending" ? "Verzenden..." : "Versturen"}
                        </button>

                        <p className="contact-form__hint">Velden met * zijn verplicht.</p>
                        {status === "sent" ? (
                            <p className="contact-form__message contact-form__message--success">
                                Uw bericht is verzonden.
                            </p>
                        ) : null}
                        {status === "error" ? (
                            <p className="contact-form__message contact-form__message--error">
                                Het verzenden is niet gelukt. Probeer het later opnieuw of neem direct
                                contact op via telefoon of e-mail.
                            </p>
                        ) : null}
                    </form>
                </div>

                <div className="contact-panel contact-panel--accent">
                    <h2>Direct contact</h2>
                    <p>Voor vragen kunt u vrijblijvend contact opnemen via:</p>
                    <a className="contact-link" href={siteMeta.phoneHref}>
                        {siteMeta.phone}
                    </a>
                    <a className="contact-link" href={siteMeta.emailHref}>
                        {siteMeta.email}
                    </a>
                    <p>Graag tot ziens op het spreekuur.</p>
                    <p>Vriendelijke groet, Rita Wilschut</p>
                    <p>
                        Door het contactformulier in te vullen gaat u akkoord met de{" "}
                        <a href="/Privacyverklaring.pdf" target="_blank" rel="noreferrer">
                            privacyverklaring
                        </a>
                        .
                    </p>
                </div>
            </section>

            <section className="schedule-section">
                <div className="schedule-header">
                    <p className="section-label">Spreekuren</p>
                    <h2>Beschikbare tijden en locaties</h2>
                </div>

                <div className="schedule-grid">
                    {Object.entries(spreekuren).map(([day, slots]) => (
                        <article className="schedule-card" key={day}>
                            <h3>{day.charAt(0).toUpperCase() + day.slice(1)}</h3>
                            {day === "woensdag" ? (
                                <p className="schedule-card__note">
                                    De spreekuurtijden wisselen elkaar wekelijks af.
                                </p>
                            ) : null}
                            {slots.map((slot, index) => (
                                <div className="schedule-card__slot" key={`${day}-${slot.time}-${slot.location}`}>
                                    {day === "woensdag" ? (
                                        <h4 className="schedule-card__week">Week {index === 0 ? "A" : "B"}</h4>
                                    ) : null}
                                    <strong>{slot.time}</strong>
                                    <span>{slot.location}</span>
                                </div>
                            ))}
                            {day === "woensdag" ? (
                                <p className="schedule-card__note schedule-card__note--footer">
                                    Neem contact op voor de spreekuurtijden op uw gewenste datum.
                                </p>
                            ) : null}
                        </article>
                    ))}
                </div>
            </section>
        </>
    );
}
